<div id="main-navigation" class="nav" [ngClass]="{'horizontal':layout === 'horizontal', 'vertical':layout === 'vertical'}">

    <!-- Vertical Navigation Layout -->
    <ng-container *ngIf="layout === 'vertical'">

        <ng-container *ngFor="let item of navigationModel">

            <wtf-nav-vertical-group *ngIf="item.type=='group'" [item]="item"></wtf-nav-vertical-group>
            <wtf-nav-vertical-collapse *ngIf="item.type=='collapse'" [item]="item"></wtf-nav-vertical-collapse>
            <wtf-nav-vertical-item *ngIf="item.type=='item'" [item]="item"></wtf-nav-vertical-item>

        </ng-container>

    </ng-container>
    <!-- / Vertical Navigation Layout -->

    <!-- Horizontal Navigation Layout -->
    <ng-container *ngIf="layout === 'horizontal'">

        <ng-container *ngFor="let item of navigationModel">

            <wtf-nav-horizontal-collapse *ngIf="item.type=='group'" [item]="item"></wtf-nav-horizontal-collapse>
            <wtf-nav-horizontal-collapse *ngIf="item.type=='collapse'" [item]="item"></wtf-nav-horizontal-collapse>
            <wtf-nav-horizontal-item *ngIf="item.type=='item'" [item]="item"></wtf-nav-horizontal-item>

        </ng-container>

    </ng-container>
    <!-- / Horizontal Navigation Layout -->

</div>